export const korgBass = [.7,0,22,,.07,.07,2,0,,,.5,.01];
export const korgFilter = [,0,245,0,0,0.48,2,,0,0,0,,,,0,0.02,0.01];
export const piano = [.5,0,196,,.08,.5,3];
export const ringPiano = [0.75,0,196,0,0.08,0.18,3];
export const polySynth = [,0,25,0.002,0.02,0.08,3,,,,,,,,,0.1,0.01];
export const synthBrass = [0.9,0,143,,,.35,3,,,,,,,,,];
export const hallBrass = [,0,232,.01,.09,.15,2,,,,,,154.87,,,,.26];
export const digDug = [,0,23,,,.2,3,5,,,0];
